export default {
  name: 'change-list',
  created () {
    this.$store.dispatch('SHOP_SEARCH')

    if (this.$router.currentRoute.query.keep !== 'true') {
      this.clearSearchParams()
      this.search(false)
    } else {
      if (this.$store.getters.patientInformationSearchParams) {
        this.shopId = this.$store.getters.patientInformationSearchParams['shop_id']
        this.facilityId = this.$store.getters.patientInformationSearchParams['facility_id']
        this.facilityName = this.$store.getters.patientInformationSearchParams['facility_name']
        this.clinicId = this.$store.getters.patientInformationSearchParams['clinic_id']
        this.clinicName = this.$store.getters.patientInformationSearchParams['clinic_name']
        this.careOfficeId = this.$store.getters.patientInformationSearchParams['care_office_id']
        this.careOfficeName = this.$store.getters.patientInformationSearchParams['careoffice_name']
        this.patientName = this.$store.getters.patientInformationSearchParams['patient_name']
      }
    }
  },
  data () {
    return {
      patientName: '',
      facilityId: null,
      facilityName: '',
      clinicId: null,
      clinicName: '',
      careOfficeId: null,
      careOfficeName: '',
      shopId: null
    }
  },
  computed: {
    patientInfos () {
      return this.$store.getters.patientInfos
    },
    facilities () {
      return this.$store.getters.facilities
    },
    careOffices () {
      return this.$store.getters.careOffices
    },
    clinics () {
      return this.$store.getters.clinics
    },
    shops () {
      return this.$store.getters.shops
    },
    nextPage () {
      return this.$store.getters.patientInfosNextPage
    },
    canManage () {
      return this.$store.getters.canManage
    },
    isFacility () {
      return this.$store.getters.isFacility
    },
    isCareOffice () {
      return this.$store.getters.isCareOffice
    },
    isClinic () {
      return this.$store.getters.isClinic
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    }
  },
  methods: {
    search (readMore) {
      var url   = null
      var clear = true
      if (readMore) {
        url   = this.$store.getters.patientInfosNextPage
        clear = false
      }

      var data = {'patient_name': this.patientName, 'facility_id': this.facilityId, 'facility_name': this.facilityName, 'clinic_id': this.clinicId, 'clinic_name': this.clinicName, 'care_office_id': this.careOfficeId, 'careoffice_name': this.careOfficeName, 'shop_id': this.shopId}

      this.$store.dispatch('PATIENT_INFORMATION_SEARCH',  {url: url, clear: clear, data: data})
    },
    getFacilities () {
      this.facilityId = null
      this.$store.dispatch('FACILITY_SEARCH', {data: {'facility_name': this.facilityName, 'shop_id': this.shopId}})
    },
    clearFacilities () {
      this.$store.dispatch('FACILITY_CLEAR', 500)
    },
    setSearchFacility (facilityId, facilityName) {
      console.log("setFacilityName - facilityName: " + facilityName)
      this.facilityId   = facilityId
      this.facilityName = facilityName
    },
    getCareOffices () {
      this.careOfficeId = null
      this.$store.dispatch('CARE_OFFICE_SEARCH', {data: {'careoffice_name': this.careOfficeName, 'shop_id': this.shopId}})
    },
    clearCareOffices () {
      this.$store.dispatch('CARE_OFFICE_CLEAR', 500)
    },
    setSearchCareOffice (careOfficeId, careOfficeName) {
      console.log("setCareOfficeName - careOfficeName: " + careOfficeName)
      this.careOfficeId   = careOfficeId
      this.careOfficeName = careOfficeName
    },
    getClinics () {
      this.clinicId = null
      this.$store.dispatch('CLINIC_SEARCH', {data: {'clinic_name': this.clinicName, 'shop_id': this.shopId}})
    },
    clearClinics () {
      this.$store.dispatch('CLINIC_CLEAR', 500)
    },
    setSearchClinic (clinicId, clinicName) {
      console.log("setClinicName - clinicName: " + clinicName)
      this.clinicId   = clinicId
      this.clinicName = clinicName
    },
    getShops () {
      this.$store.dispatch('SHOP_SEARCH')
    },
    showMedicineList (idx) {
      var patientInfos = this.patientInfos
      var patientInfo  = patientInfos[idx]
      this.$store.dispatch('SET_PATIENT', {patient: patientInfo})

      this.$router.push({ path: '/patient/' + patientInfo.id + '/medicines', query: { prev: 'change_list'}})
    },
    showChangeDetail (idx) {
      var patientInfos = this.patientInfos
      var patientInfo  = patientInfos[idx]
      this.$store.dispatch('SET_PATIENT', {patient: patientInfo})

      this.$router.push({ path: '/change/' + patientInfo.id})
    },
    clearSearchParams: function() {
      this.shopId = null
      if (this.$store.getters.canManage && !this.shopId) {
        this.shopId = this.$store.getters.currentShopId
      }
      this.facilityId = null
      this.facilityName = ''
      this.clinicId = null
      this.clinicName = ''
      this.careOfficeId = null
      this.careOfficeName = ''
      this.PatientName = ''

      this.$store.dispatch('CLEAR_PATIENT_INFORMATION_SEARCH_PARAMS')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/change-list.js